var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('div',{staticClass:"line"},[_c('DatePicker',{staticStyle:{"width":"200px"},attrs:{"type":"daterange","options":_vm.date_option,"placeholder":"选择付款申请日期"},on:{"on-change":_vm.daterangeChange}}),_c('Button',{attrs:{"type":"primary"},on:{"click":_vm.exportInvoice}},[_vm._v(" 导出 ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }